export const products = [
  {
    id: 1,
    img: "../img/prime-dev.png",
    link: "https://primedev-eg.com",
  },
  
  {
    id: 2,
    img: "../img/ramsesmedical.png",
    link: "https://ramsesmedical.net/",
  },
  {
    id: 3,
    img: "../img/ecommerce.png",
    link: "https://ecommerce-sanity-stripe-murex.vercel.app/",
  },
];
